import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonModal,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import { closeOutline, person, personOutline } from "ionicons/icons";
import { useRef } from "react";
import "./AuthModal.scss";
import { useAppContext } from "../../services/app-context.service";
import UserProfile from "./UserProfile";
import UserMenu from "./UserMenu";
import AuthBody from "./AuthBody";
import { AuthContextProvider, defaultAuthData } from "../../services/auth-context.service";

export let authModalRef: React.RefObject<HTMLIonModalElement>;

const AuthModal: React.FC = () => {
    authModalRef = useRef<HTMLIonModalElement>(null);
    const { user } = useAppContext();

    function onClick() {
        defaultAuthData.role_id = 3;
        authModalRef.current?.present();
    }

    return (
        <>
            <IonButton fill="clear" onClick={onClick} id="btn-auth-modal" aria-label="Account">
                {user.token ? <IonIcon size="large" icon={person} /> : <IonIcon size="large" icon={personOutline} />}
            </IonButton>
            <IonModal ref={authModalRef} id="auth-modal">
                {user.token ? (
                    <>
                        <IonHeader>
                            <IonToolbar color="light">
                                <IonTitle>My Account</IonTitle>
                                <IonButtons slot="end">
                                    <IonButton fill="clear" onClick={() => authModalRef.current?.dismiss()}>
                                        <IonIcon icon={closeOutline} />
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent color="light">
                            <div className="auth-account-container">
                                <div className="account-col menu-col">
                                    <h3>Menu</h3>
                                    <UserMenu />
                                </div>
                                <div className="account-divider"></div>
                                <div className="account-col profile-col">
                                    <h3>My Profile</h3>
                                    <UserProfile />
                                </div>
                            </div>
                        </IonContent>
                    </>
                ) : (
                    <AuthContextProvider>
                        <AuthBody />
                    </AuthContextProvider>
                )}
            </IonModal>
        </>
    );
};

export default AuthModal;
